<div class="mt-2 grid grid-cols-2 gap-4">
    <div class="flex flex-col gap-2 sm:col-span-full">
        <label for="impression-tracking-url" class="block text-sm/6 font-medium text-gray-900 dark:text-white">
            Impression Tracking URL
            <p class="text-xs text-secondary">Optional third-party tracking endpoint for ad impressions.</p>
        </label>
        <input id="impression-tracking-url" type="url" name="impressionTrackingUrl" inputmode="url"
            placeholder="https://example.com/track?event=impression"
            [value]="createSparkCampaignService.impression_tracking_url() ?? ''"
            (input)="onImpressionTrackingUrlInput($event)"
            class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-primary" />
    </div>


    <div class="flex flex-col gap-2 sm:col-span-full">
        <label for="click-tracking-url" class="block text-sm/6 font-medium text-gray-900 dark:text-white">
            Click Tracking URL
            <p class="text-xs text-secondary">DCM, Sizmek, or Flashtalking tags are not supported for placement on
                Pangle.</p>
        </label>
        <input id="click-tracking-url" type="url" name="clickTrackingUrl" inputmode="url"
            placeholder="https://example.com/track?event=click"
            [value]="createSparkCampaignService.click_tracking_url() ?? ''" (input)="onClickTrackingUrlInput($event)"
            class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-primary" />
    </div>
</div>